<template>
  <div :class="prefix+'__panel'">
    <!--日期面板-->
    <div :class="[prefix+'__row','clearfix']">
      <div v-for="(item, col) in showMonths" :key="col" :class="{[prefix + '__row--start']: col===0, [prefix+'__row--end']: col===1}">
        <transition
          name="flipY"
          mode="out-in"
          @after-leave="dataTransitionSate=''"
          @leave="dataTransitionSate='leave'"
        >
          <t-date-table
            v-if="isDateType"
            v-show="item.panel==='date'"
            ref="dateTable"
            :min-selected="minPicked"
            :max-selected="maxPicked"
            :range-state="rangeState"
            :has-prev="!isRange || (isRange && col===0)"
            :has-next="!isRange || (isRange && col===1)"
            :default-draw-date="item.drawDate"
            :is-range="isRange"
            :min-select-range="minSelectRange"
            :max-select-range="maxSelectRange"
            :unselectable-days-of-week="unselectableDaysOfWeek"
            @changeDrawDate="$_onDateTableChangeDrawDate"
            @changePicker="item.panel=arguments[0]"
            @changerange="$_onDateTableChangeRange"
            @pick="$_onDateTablePick"
          ></t-date-table>
        </transition>
        <t-year-table
          v-show="!dataTransitionSate && item.panel==='year'"
          :default-draw-year="item.drawDate.year()"
          :min-selected="minPicked"
          :max-selected="maxPicked"
          :min-select-range="minSelectRange"
          :max-select-range="maxSelectRange"
          :year-range="yearRange"
          transition="flipY"
          @pick="$_onYearTablePick(arguments[0],col)"
        ></t-year-table>
        <t-month-table
          v-show="!dataTransitionSate && item.panel==='month'"
          :default-draw-date="item.drawDate"
          :has-prev="!isRange || (isRange && col===0)"
          :has-next="!isRange || (isRange && col===1)"
          :is-range="isRange && isMonthType"
          :min-selected="minPicked"
          :max-selected="maxPicked"
          :min-select-range="minSelectRange"
          :max-select-range="maxSelectRange"
          transition="flipY"
          @changePicker="item.panel=arguments[0]"
          @changeDrawDate="$_onDateTableChangeDrawDate(arguments[0], col)"
          @pick="$_onMonthTablePick(arguments[0],col)"
        ></t-month-table>
        <t-time-spinner
          v-show="!dataTransitionSate && item.panel==='time'"
          ref="timePicker"
          :picked="item.picked"
          :hour="item.hour"
          :is-only-time-type="isOnlyTimeType"
          :minute="item.minute"
          :second="item.second"
          :min-select-range="minSelectRange"
          :max-select-range="maxSelectRange"
          :format="isOnlyTimeType ? 'HH:mm' : 'HH:mm:ss'"
          transition="flipY"
          @pick="$_onTimeSpinnerPick(arguments[0],arguments[1],col)"
        ></t-time-spinner>
      </div>
      <t-shortcuts-aside
        v-if="showShortcut"
        :is-range="isRange"
        :shortcut-options="shortcutOptions"
        @shortcut-pick="$_shortcutPick"
      >
      </t-shortcuts-aside>
    </div>
    <!--footer-->
    <div v-if="isTimeType===true" :class="[prefix+'__footer','text-right']">
      <t-button v-if="isOnlyTimeType===false" color="primary" ghost :disabled="!hasPickedDate" @click.stop="switchTimePicker">{{ getTimeHandle }}</t-button>
      <t-button :disabled="isOnlyTimeType===false && !hasPickedDate" color="primary" @click.stop="$_onOKButtonClick">{{ t('t.datepicker.ok') }}</t-button>
    </div>
    <template v-else>
      <div v-show="confirm" :class="[prefix+'__footer','text-right']">
        <t-button color="primary" @click.stop="$_onOKButtonClick">{{ t('t.datepicker.ok') }}</t-button>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import TShortcutsAside from './shortcuts-aside.vue'
import TDateTable from '../basic/date-table.vue'
import TYearTable from '../basic/year-table.vue'
import TMonthTable from '../basic/month-table.vue'
import TTimeSpinner from '../basic/time-spinner.vue'
import locale from '@/mixins/locale'
import { TButton } from '../../button'
import {
  PREFIX_DATE_PICK_CLASS
} from '../constants'
export default {
  name: 'TDatePanel',
  components: {
    TShortcutsAside, TDateTable, TYearTable, TMonthTable, TTimeSpinner, TButton
  },
  mixins: [ locale ],
  props: {
    type: { // 可选取值为：year|month|date|week|dateRange|dateTimeRange
      type: String,
      default: 'date'
    },
    isRange: Boolean,
    // NOTE: 没用到？
    // showToday: Boolean,
    shortcutOptions: {
      type: Object,
      default: () => {}
    },
    defaultDrawDate: {
      type: Object,
      default: () => {}
    }, // moment
    minSelected: {
      type: Object,
      default: () => {}
    }, // moment，default:null
    maxSelected: {
      type: Object,
      default: () => {}
    }, // moment，default:null
    minSelectRange: {
      type: Object,
      default: () => {}
    }, // moment，default:null
    maxSelectRange: {
      type: Object,
      default: () => {}
    }, // moment，default:null
    confirm: Boolean,
    showShortcut: {
      type: Boolean,
      default: false
    },
    visible: Boolean,
    unselectableDaysOfWeek: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      prefix: PREFIX_DATE_PICK_CLASS,
      dataTransitionSate: '',
      isPick: false,
      defaultPanel: 'date',
      yearRange: 10,
      prevStatus: 'prev',
      nextStatus: 'next',
      cmdPrevDisabled: false,
      cmdNextDisabled: false,
      drawDate: this.defaultDrawDate,
      selfShortcuts: [],
      showMonths: [],
      rangeState: {
        endDate: null,
        selecting: false
      },
      minPicked: this.minSelected || null,
      maxPicked: this.maxSelected || null
    }
  },
  computed: {
    isDateType () {
      return /date/i.test(this.type)
    },
    isMonthType () {
      return /month/i.test(this.type)
    },
    isYearType () {
      return /year/i.test(this.type)
    },
    isTimeType () {
      return /time/i.test(this.type)
    },
    isOnlyTimeType () {
      return /^time/i.test(this.type)
    },
    hasPickedDate () {
      if (this.isRange === true) {
        return !!(this.minPicked && this.maxPicked)
      } else {
        return !!this.minPicked
      }
    },
    getTimeHandle () {
      if (this.showMonths[ 0 ].panel === 'date') {
        return this.t('t.datepicker.selectTime')
      } else if (this.showMonths[ 0 ].panel === 'time') {
        return this.t('t.datepicker.selectDate')
      } else {
        return ''
      }
    },
    datePicked () {
      return [ this.minPicked, this.maxPicked ]
    }
  },
  watch: {
    defaultDrawDate(newValue) {
      this.drawDate = newValue
    },
    datePicked (newValue) {
      if (!this.isTimeType) {
        this.publishPick(newValue)
      }
    },
    minSelected (newValue) {
      let isChange = false
      if (!newValue || !newValue.isSame(this.minPicked)) {
        isChange = true
      }
      this.minPicked = newValue || null
      if (isChange === true) {
        this.init()
      }
    },
    maxSelected (newValue) {
      let isChange = false
      if (!newValue || !newValue.isSame(this.maxPicked)) {
        isChange = true
      }
      if (!this.isRange) {
        this.maxPicked = newValue || null
      } else {
        if (this.rangeState.selecting === false) {
          this.maxPicked = newValue || null
        }
      }
      if (isChange === true) {
        this.init()
      }
    },
    dataTransitionSate (newValue) {
      if (!newValue) {
        this.ajustTimeSpinnerScrollTop()
        if (this.minPicked && this.minPicked.isValid()) {
          this.showMonths[0].picked = this.minPicked.format('YYYY/MM/DD')
        }
        if (this.showMonths[1]) {
          if (this.maxPicked && this.maxPicked.isValid()) {
            this.showMonths[1].picked = this.maxPicked.format('YYYY/MM/DD')
          }
        }
      }
    },
    visible (value) {
      if (value === false) { // 隐藏时还原面板
        setTimeout(() => {
          for (let item of this.showMonths) {
            item.panel = this.defaultPanel
          }
        }, 300)
      } else if (this.isOnlyTimeType) {
        this.ajustTimeSpinnerScrollTop()
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    ajustTimeSpinnerScrollTop () {
      this.$refs.timePicker[0] && this.$refs.timePicker[0].ajustScrollTop()
      if (this.showMonths[1]) {
        this.$refs.timePicker[1] && this.$refs.timePicker[1].ajustScrollTop()
      }
    },
    pickDate (event) {
      if (event.target.hasAttribute('disabled')) {
        return
      }
      if (this.isTimeType === true) {
        if (moment.isMoment(this.minPicked) && this.minPicked.isValid) {
          this.minPicked.hour(this.showMonths[ 0 ].hour)
          this.minPicked.minute(this.showMonths[ 0 ].minute)
          this.minPicked.second(this.showMonths[ 0 ].second)
        }
        if (moment.isMoment(this.maxPicked) && this.maxPicked.isValid) {
          this.maxPicked.hour(this.showMonths[ 1 ].hour)
          this.maxPicked.minute(this.showMonths[ 1 ].minute)
          this.maxPicked.second(this.showMonths[ 1 ].second)
        }
      }
      if (this.isRange === true) {
        if (this.minPicked && this.maxPicked) {
          this.isPick = true
          this.$emit('pick', [ this.minPicked, this.maxPicked ])
        }
      } else {
        if (this.minPicked) {
          this.isPick = true
          this.$emit('pick', [ this.minPicked, null ])
        }
      }
    },
    updateDrawDate () {
      for (let i = 0; i < this.showMonths.length; i++) {
        let _newObj = Object.assign({}, this.showMonths[ i ])
        _newObj.drawDate = moment({ year: this.drawDate.year(), month: this.drawDate.month() }).add(i, 'M')
        this.$set(this.showMonths, i, _newObj)
        if (this.isDateType) {
          this.$refs.dateTable[ i ].updateCalendar(this.showMonths[ i ].drawDate)
        }
      }
    },
    $_updateMonthDrawDate (newObj, col) {
      for (let i = 0; i < this.showMonths.length; i++) {
        if (col > 0) {
          if (i === 0) {
            let _newObj = Object.assign({}, this.showMonths[ i ])
            _newObj.drawDate = moment({ year: this.drawDate.year() }).add(i, 'Y')
            this.$set(this.showMonths, i, _newObj)
          } else {
            let _newObj = Object.assign({}, this.showMonths[ i ])
            _newObj.drawDate = moment({ year: this.drawDate.year() }).add(i, 'Y')
            this.$set(this.showMonths, i, _newObj)
          }
        } else {
          if (i === 0) {
            let _newObj = Object.assign({}, this.showMonths[ i ])
            _newObj.drawDate = moment({ year: this.drawDate.year() - 1 }).add(i, 'Y')
            this.$set(this.showMonths, i, _newObj)
          } else {
            let _newObj = Object.assign({}, this.showMonths[ i ])
            _newObj.drawDate = moment({ year: this.drawDate.year() - 1 }).add(i, 'Y')
            this.$set(this.showMonths, i, _newObj)
          }
        }
      }
    },
    updateSingDrawDate (col = 0) {
      let _newObj = Object.assign({}, this.showMonths[ col ])
      _newObj.drawDate = moment({ year: this.drawDate.year(), month: this.drawDate.month() }).add(col, 'M')
      if (col === 0 && this.isRange && _newObj.drawDate.isAfter(this.showMonths[ 1 ].drawDate)) {
        this.updateDrawDate()
        return
      }
      if (col === 1 && this.isRange && _newObj.drawDate.isBefore(this.showMonths[ 0 ].drawDate)) {
        this.updateDrawDate()
        return
      }
      this.$set(this.showMonths, col, _newObj)
      if (this.isDateType) {
        this.$refs.dateTable[ col ].updateCalendar(this.showMonths[ col ].drawDate)
      }
    },
    switchTimePicker (event) {
      if (!this.hasPickedDate) {
        return
      }
      let _panel = this.showMonths[ 0 ].panel === 'time' ? 'date' : 'time'
      this.showMonths[ 0 ].panel = _panel
      if (this.showMonths[ 1 ]) {
        this.showMonths[ 1 ].panel = _panel
      }
    },
    showYearPicker (col) {
      this.showMonths[ col ].panel = 'year'
    },
    showMonthPicker (col) {
      this.showMonths[ col ].panel = 'month'
    },
    isSameMonth (moment1, moment2) {
      return moment1.year() === moment2.year() && moment1.month() === moment2.month()
    },
    $_onDateTablePick (dateObj) {
      this.minPicked = null
      if (dateObj.minDate && moment.isMoment(dateObj.minDate)) {
        this.minPicked = moment({ year: dateObj.minDate.year(), month: dateObj.minDate.month(), date: dateObj.minDate.date() })
      }
      if (this.showMonths[0]) {
        if (this.isTimeType) {
          this.showMonths[0].hour = 0
          this.showMonths[0].minute = 0
          this.showMonths[0].second = 0
        }
      }
      this.maxPicked = null
      if (dateObj.maxDate && moment.isMoment(dateObj.maxDate)) {
        this.maxPicked = moment({ year: dateObj.maxDate.year(), month: dateObj.maxDate.month(), date: dateObj.maxDate.date() })
      }
      if (this.showMonths[1]) {
        if (this.isTimeType) {
          this.showMonths[1].hour = 0
          this.showMonths[1].minute = 0
          this.showMonths[1].second = 0
        }
      }
      if (!this.confirm) {
        if (this.isRange === true) {
          if (this.minPicked && this.maxPicked) {
            this.firePanelPickEvent()
          }
        } else {
          if (this.minPicked) {
            this.firePanelPickEvent()
          }
        }
      }
      this.$emit('range-pick', {
        minDate: this.minPicked,
        maxDate: this.maxPicked
      })
    },
    $_onDateTableChangeRange (dateObj) {
      this.minPicked = dateObj.minDate ? Object.assign(dateObj.minDate) : null
      this.maxPicked = dateObj.maxDate ? Object.assign(dateObj.maxDate) : null
      this.rangeState = dateObj.rangeState
    },
    $_onDateTableChangeDrawDate (dateObj, col) {
      this.drawDate = dateObj
      if (this.isMonthType && this.isRange) {
        this.$_updateMonthDrawDate(dateObj, col)
      } else {
        this.updateDrawDate()
      }
    },
    $_onYearTablePick (year, col) {
      if (year) {
        this.$set(this.drawDate, this.drawDate.year(year))
        if (this.isDateType) { // 日期面板
          this.updateSingDrawDate(col)
        }
        if (this.defaultPanel === 'year') { // 年月面板
          let _newDate = moment({ year: year })
          if (_newDate.isValid()) {
            if (col === 0) {
              this.minPicked = _newDate
            } else if (col === 1) {
              this.maxPicked = _newDate
            }
          }
          if (!this.confirm) {
            this.firePanelPickEvent()
          }
        } else {
          if (this.defaultPanel === 'month') {
            this.updateSingDrawDate(col)
          }
          this.showMonths[ col ].panel = this.defaultPanel
        }
      }
    },
    $_onMonthTablePick (drawDate, col) { // month从1开始
      if (Object.prototype.toString.call(drawDate) === '[object Array]') {
        this.minPicked = null
        if (drawDate[0] && moment.isMoment(drawDate[0])) {
          this.minPicked = moment({ year: drawDate[0].year(), month: drawDate[0].month() })
        }
        this.maxPicked = null
        if (drawDate[1] && moment.isMoment(drawDate[1])) {
          this.maxPicked = moment({ year: drawDate[1].year(), month: drawDate[1].month() })
        }
        if (!this.confirm) {
          if (this.isRange === true) {
            if (this.minPicked && this.maxPicked) {
              this.firePanelPickEvent()
            }
          } else {
            if (this.minPicked) {
              this.firePanelPickEvent()
            }
          }
        }
      } else {
        if (drawDate) {
          let month = drawDate.month()
          this.drawDate = drawDate
          if (this.isDateType) {
            this.updateSingDrawDate(col)
            this.showMonths[ col ].panel = 'date'
          }
          if (this.defaultPanel === 'month') {
            let _newDate = moment({ year: drawDate.year(), month: month })
            if (_newDate.isValid()) {
              if (col === 0) {
                this.minPicked = _newDate
              } else if (col === 1) {
                this.maxPicked = _newDate
              }
            }
            if (!this.confirm) {
              this.firePanelPickEvent()
            }
          }
        }
      }
    },
    $_onTimeSpinnerPick (type, time, col) {
      this.showMonths[ col ][ type ] = time
      if (this.isOnlyTimeType === false) {
        let isValid = this.isRange ? this.minPicked && this.maxPicked : this.minPicked
        if (!isValid) {
          return
        }
      }
      let _obj = col === 0 ? this.minPicked : this.maxPicked
      if (type === 'hour') {
        _obj.hour(time)
      } else if (type === 'minute') {
        _obj.minute(time)
      } else {
        _obj.second(time)
      }
    },
    $_onOKButtonClick () {
      this.$_checkDateValid()
      this.firePanelPickEvent()
    },
    firePanelPickEvent() {
      this.$emit('panel-pick', this.datePicked)
    },
    getShowMonths () {
      let panel = 'date'
      if (this.isYearType === true) {
        panel = 'year'
      }
      if (this.isMonthType === true) {
        panel = 'month'
      }
      if (this.isTimeType === true) {
        panel = 'time'
      }
      if (this.isDateType === true) {
        panel = 'date'
      }
      this.defaultPanel = panel
      let _showMonthObj = {
        panel: panel,
        drawDate: this.drawDate,
        displayYear: this.drawDate.year(),
        hour: 0,
        minute: 0,
        second: 0
      }
      let showMonthArr = []
      let monthSize = this.isRange ? 2 : 1
      for (let i = 0; i < monthSize; i++) {
        let newObj = Object.assign({}, _showMonthObj)
        if (i === 0 && this.minPicked) {
          newObj.hour = this.minPicked.hour()
          newObj.minute = this.minPicked.minute()
          if (!this.isOnlyTimeType) {
            newObj.second = this.minPicked.second()
          }
        }
        if (i > 0 && this.maxPicked) {
          newObj.hour = this.maxPicked.hour()
          newObj.minute = this.maxPicked.minute()
          if (!this.isOnlyTimeType) {
            newObj.second = this.maxPicked.second()
          }
        }
        // NOTE: 对于是monthRange的情况需要进行修改
        if (this.isMonthType && this.isRange) {
          newObj.drawDate = moment({ year: this.drawDate.year() }).add(i, 'Y')
          newObj.displayYear = newObj.drawDate.year()
        } else {
          newObj.drawDate = moment({ year: this.drawDate.year(), month: this.drawDate.month() }).add(i, 'M')
          newObj.displayYear = newObj.drawDate.year()
        }
        showMonthArr.push(newObj)
      }
      return showMonthArr
    },
    // 通知选取的日期
    publishPick (newValue) {
      if (!confirm) {
        this.$emit('pick', newValue)
      }
    },
    init () {
      // init month view
      this.showMonths = this.getShowMonths()
    },
    $_shortcutPick (selectDate) {
      if (!this.confirm) {
        this.$emit('panel-pick', selectDate)
      } else {
        if (Array.isArray(selectDate)) {
          this.minPicked = selectDate[0]
          this.showMonths[0].drawDate = moment({ year: this.minPicked.year(), month: this.minPicked.month() })
          this.showMonths[1].drawDate = moment({ year: this.minPicked.year(), month: this.minPicked.month() }).add(1, 'M')
          this.maxPicked = selectDate[1]
        } else {
          this.minPicked = selectDate
          this.showMonths[0].drawDate = moment({ year: selectDate.year(), month: selectDate.month(), date: selectDate.date() })
        }
      }
    },
    $_checkDateValid() {
      if (this.minPicked) {
        if (this.minSelectRange && this.minPicked.isBefore(this.minSelectRange)) {
          this.minPicked = this.minSelectRange
        }
        if (this.maxSelectRange && this.minPicked.isAfter(this.maxSelectRange)) {
          this.minPicked = this.maxSelectRange
        }
      }
      if (this.maxPicked) {
        if (this.minSelectRange && this.maxPicked.isBefore(this.minSelectRange)) {
          this.maxPicked = this.minSelectRange
        }
        if (this.maxSelectRange && this.maxPicked.isAfter(this.maxSelectRange)) {
          this.maxPicked = this.maxSelectRange
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/date-picker/panel/date-panel.vue